<template>
    <div class="deground">
        <headerpage :status="3"></headerpage>
        <div class="box" :style="{height:height+'px'}">
            <img src="../../assets/images/qie/10.png" class="box_top_img" />
            <img :src="common.park_pic | addurl" style="width: 100%;height: 100%;position: absolute;top: 0;" />
            <div class="box_bot">
                <div class="box_bot_cet">
                    <input placeholder="请输入公司名称" v-model="keyword"  @change="tosearch"  class="box_bot_cet_left" />
                    <div class="box_bot_cet_right" @click="tosearch">
                        <i class="el-icon-search" style="margin-right: 5px;"></i>
                        搜索
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="adaptation" style="background-color: #f6f8f7;">
            <div class="box1 tabstype" style="display: flex;align-items: center;height: 60px;justify-content: space-between;">
                <div class="box1_cent" v-for="(item,index) in foollist" :class="activeName == index?'box1_cent_sty':''" @click="foolchange(index)">
                    {{index==0?item:item}}
                <template v-if="activeName != index">
                    <div class="box1_heng" v-if="  Number(activeName-1) != index"></div>
                </template>
                 
                </div>
                <el-tabs type="card" v-model="activeName" @tab-click="foolchange(activeName)" >
                    <el-tab-pane :label="index==0?item:item+'号楼'" :name="String(index)" v-for="(item,index) in foollist"  ></el-tab-pane>
                </el-tabs>
            </div>
        </div> -->
        <div style="height: 30px;"></div>

         <div class="box8 adaptation" style="background-color: #f6f8f7;">
            <div class="box8_cent">
                <div class="box8_cent_left">楼号：</div>
               <div class="box8_cent_right">
                <el-select v-model="activeName" placeholder="请选择" @change="foolchange">
                    <el-option
                    v-for="item in foollist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
               </div>
            </div>
            <div class="box8_cent">
                <div class="box8_cent_left">行业：</div>
               <div class="box8_cent_right">
                <el-select v-model="industry" placeholder="请选择" @change="foolchange">
                    <el-option
                    v-for="item in industrylist"
                    :key="item"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
               </div>
            </div>
            <el-button type="info" @click="cong">重置</el-button>
         </div>

      


        <div style="height: 30px;"></div>





        <div class="box9 adaptation tablecss">

            <el-table :data="list" style="width: 100%;">
                <el-table-column prop="company_name" label="企业名称" width="300px">
                </el-table-column>
                <el-table-column prop="new_address" label="注册地址">
                </el-table-column>
                <el-table-column prop="industry" label="所属行业">
                </el-table-column>
                <el-table-column prop="policy_count" label="政策数量">
                </el-table-column>
                <el-table-column prop="total_money" label="补助金额（万元）">
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <div class="detaii" @click="detailjump(scope.row.id)">查看详情</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="adaptation pagecss">
            <el-pagination background :page-size="pagesize" :hide-on-single-page="true" layout="prev, pager, next"
                @current-change="handleCurrentChange" :current-page="currentPage" :total="totalnum">
            </el-pagination>
        </div>
        <div style="height: 40px;"></div>
    </div>
</template>
  
<script>
import windowchange from '@/util/window'
import headerpage from '../../components/header/header.vue';
import { mapGetters } from 'vuex'
export default {
    components: { headerpage },
    mixins: [windowchange],
    computed: {
        ...mapGetters({
            common: 'user/common',
        }),
    },
    data() {
        return {
            industrylist:['全部'],
            industry:'',
            keyword: "",
            typelist: [],
            firstid: "",
            unit: 0,
            city: 0,
            area: 0,
            year: 0,
            newunit: 0,
            list: [],
            totalnum: 0,
            currentPage: 1,
            pagesize: 20,
            advertiselist: [],
            weimg: '/uploads/erweima.png',
            showimg: false,
            dengji: 0,
            showopen: false,
            activeName:'',
            // height: 500,
            // height1: 500,
            foollist:[{
                id:0,
                name:'全部'
            },{
                id:1,
                name:'1号楼'
            },{
                id:2,
                name:'2号楼'
            },{
                id:3,
                name:'3号楼'
            },{
                id:4,
                name:'4号楼'
            },{
                id:7,
                name:'7号楼'
            },
            {
                id:10,
                name:'10号楼'
            }],
            foolindex:0
        }
    },
    methods: {
        cong(){
            this.industry = ''
            this.activeName = ''
            this.page = 1;
            this.list = [];
            this.getlist();
            this.$forceUpdate();
        },
        foolchange(index){
            // this.activeName = index
            // this.foolindex = index
            this.page = 1;
            this.list = [];
            this.getlist();
            this.$forceUpdate();
        },
        config() {
            this.$https.post(
                {
                    api: this.$api.api.demo.config,
                    type: "formData",
                },
                {},
                (response) => {


                    // this.foollist = this.foollist.concat(response.data.floor_number)
                    this.industrylist =  this.industrylist.concat(response.data.industry)
                },
                (error) => {
                    console.log(error);
                }
            );
        },
        handleCurrentChange: function (currentPage) {
            this.currentPage = currentPage;
            // console.log(this.currentPage)  //点击第几页
            // this.rightlist = [];
            this.getlist();
        },
        tochoose(index, cindex, cid, name, id) {
            console.log(this.typelist)
            for (let i in this.typelist[index].union_type) {
                this.typelist[index].union_type[i].checked = false;
            }
            console.log(id)
            this.typelist[index].union_type[cindex].checked = true;
            if (id == 18) {
                if (cid == 0) {
                    this.typelist.splice(3, 1);
                    this.city = '';
                    this.area = '';
                } else {
                    var arr = {
                        name: "区域",
                        union_type: [],
                        id: 0,
                    };
                    this.typelist[3] = arr;
                    this.getsecondlist(cid, 3);
                    this.city = this.typelist[index].union_type[cindex].id;
                }
            } else if (id == 1) {
                this.unit = this.typelist[index].union_type[cindex].id;
                console.log('unite', this.unit)
                // if(this.unit == 0){
                //    console.log('unite',this.typelist.length)
                //    this.newunit = '';
                //   if(this.typelist.length == 4){
                //     this.typelist.splice(2,1)
                //   }
                // }else{
                //   this.getnewsec(this.unit)
                // }
                this.getnewsec(this.unit)
            } else if (id == 26) {
                this.dengji = this.typelist[index].union_type[cindex].id;
                // this.unit = this.typelist[index].union_type[cindex].id;
                this.getnewsec(this.unit)
            } else if (id == 'yaer') {

                if (this.typelist[index].union_type[cindex].name == '全部') {
                    this.year = 0;
                } else {
                    this.year = this.typelist[index].union_type[cindex].name;
                }
            } else if (id == 'newunit') {
                if (this.typelist[index].union_type[cindex].name == '全部') {
                    this.newunit = 0;
                } else {
                    this.newunit = this.typelist[index].union_type[cindex].name;
                }
            } else {
                this.area = this.typelist[index].union_type[cindex].id;
            }
            this.page = 1;
            this.list = [];
            this.getlist();
            this.$forceUpdate();
        },
        getnewsec(id) {
            // get_policy_year

            var api = this.$api.api.index.get_policy_name;
            this.$https.post(
                {
                    api: api,
                    type: "formData",
                },
                {
                    unit: id,
                    dengji: this.dengji
                },
                (response) => {
                    console.log('responseresponseresponse11111', response)
                    var arr = {
                        name: "政策名称",
                        union_type: [],
                        id: 'newunit',
                    };
                    response.data.unshift({
                        name: "全部",
                        id: 0,
                        checked: true
                    });
                    // this.typelist[3] = arr;
                    arr.union_type = response.data;
                    var num = this.typelist.length - 1;
                    if (this.typelist.length == 3) {
                        this.typelist.splice(2, 0, arr);
                    } else {
                        this.typelist.splice(2, 1, arr);
                    }
                    console.log('height111', this.$refs.nameheight[0].offsetHeight)
                    // console.log('123123123',window.getComputedStyle(this.$refs.nameheight).height)
                    // this.typelist.splice(2, 0 ,arr);
                },
                (error) => {
                    console.log(error);
                }
            );
        },
        getsecondlist(id, index) {
            var api = this.$api.api.index.get_second_category;
            this.$https.post(
                {
                    api: api,
                    type: "formData",
                },
                {
                    cat_id: id,
                },
                (response) => {
                    // console.log('response',response)
                    response.data.unshift({
                        name: "全部",
                        id: 0,
                    });
                    for (let i in response.data) {
                        response.data[i]["checked"] = false;
                    }
                    response.data[0]["checked"] = true;
                    // console.log(index)
                    // console.log(response.data);
                    // console.log('typelist',this.typelist)
                    this.typelist[index].union_type = response.data;
                    this.$forceUpdate();
                    // console.log('typelist',this.typelist)
                },
                (error) => {
                    console.log(error);
                }
            );
        },
        gettoplist() {
            var api = this.$api.api.index.get_first_category;
            this.$https.post(
                {
                    api: api,
                    type: "formData",
                },
                {},
                (response) => {
                    for (let i in response.data) {
                        response.data[i]["union_type"] = [];
                    }
                    this.typelist = response.data;
                    this.getsecondlist(response.data[0].id, 0);
                    this.getsecondlist(response.data[1].id, 1);
                    this.getyear();
                },
                (error) => {
                    console.log(error);
                }
            );
        },
        getyear() {
            // get_policy_year
            var api = this.$api.api.index.get_policy_year;
            this.$https.post(
                {
                    api: api,
                    type: "formData",
                },
                {},
                (response) => {
                    console.log('responseresponseresponse11111', response)
                    var arr = {
                        name: "年份",
                        union_type: [],
                        id: 'yaer',
                    };
                    this.typelist[2] = arr;

                    response.data.unshift({
                        name: "全部",
                        id: 0,
                    });
                    for (let i in response.data) {
                        response.data[i]["checked"] = false;
                    }
                    response.data[0]["checked"] = true;
                    this.typelist[2].union_type = response.data;
                    this.$forceUpdate();
                },
                (error) => {
                    console.log(error);
                }
            );
        },
        getlist() {
            const loading = this.$loading({
                lock: true,
                text: '加载中……',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0)'
            });
            var api = this.$api.api.index.get_enterprise_list;
            this.$https.post(
                {
                    api: api,
                    type: "formData",
                },
                {
                    page: this.currentPage,
                    page_size: this.pagesize,
                    unit: this.unit,
                    city: this.city,
                    area: this.area,
                    dengji: this.dengji,
                    keyword: this.keyword,
                    year: this.year,
                    name: this.newunit,
                    building:this.activeName=='全部'?'':this.activeName,
                    industry:this.industry=='全部'?'':this.industry
                },
                (response) => {
                    console.log("response", response);
                    this.list = response.data;
                    this.totalnum = response.count;
                    loading.close();
                },
                (error) => {
                    loading.close();
                    console.log(error);
                }
            );
        },
        tosearch() {
            this.currentPage = 1;
      this.list = [];
      this.getlist();
        },
        handleClick() {

        },
        detailjump(id) {
            let routeUrl = this.$router.resolve({
                name: "enterprisedetail",
                 query: { id: id }
            });
            window.open(routeUrl.href);
            // this.$router.push({ name: 'enterprisedetail', query: { id: id } });
        }
    },
    created: function () {
        if(this.$route.query.keyword){
            this.keyword = this.$route.query.keyword;
        }
         


        // this.gettoplist()
        this.getlist();
        this.config()
    }
}
</script>
<style lang="scss">
.pagecss .el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
    background-color: #f6f8f7;
    color: #999999;
    margin: 0 5px;

}

.pagecss .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #206ad9;
    border-radius: 4px;
}

.pagecss .el-icon-arrow-left {
    margin-right: 10px;
}

.pagecss .el-icon-arrow-left:before {
    content: '上一页'
}

.pagecss .el-icon-arrow-right {
    margin-left: 10px;
}

.pagecss .el-icon-arrow-right:before {
    content: '下一页'
}

.pagecss {

    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
        background-color: #f6f8f7;
    }
}

.tabstype {
    .el-tabs--card>.el-tabs__header {
        border: 0;
        margin: 0;
    }

    .el-tabs--card>.el-tabs__header .el-tabs__nav {
        border: 0;
    }

    .el-tabs--card>.el-tabs__header .el-tabs__item {
        border: 0;
        position: relative;
        width: 150px;
        height: 60px;
        line-height: 60px;
        text-align: center;
    }

    .el-tabs--card>.el-tabs__header .el-tabs__item:last-child::after {
        width: 0;
    }

    .el-tabs--card>.el-tabs__header .el-tabs__item::after {
        content: '';
        position: absolute;
        width: 0.1px;
        font-weight: 300;
        height: 25px;
        background-color: #d2d2d2;
        top: 50%;
        transform: translate(-50%, -50%);
        right: 0;
    }

    .el-tabs__item.is-active {
        width: 190px;
        height: 80px;
        background-color: #0170c1;
        border-radius: 8px;
        color: #fff;
    }
   .el-tabs--card>.el-tabs__header .el-tabs__item{
        width: 50%;
    }
    // .el-tabs--card>.el-tabs__header .el-tabs__item.is-active::after {
    //     right: -23px;
    // }

    .el-tabs__nav-prev {
        font-size: 20px;
        line-height: 60px;
    }
    .el-tabs__nav-scroll{
        
    }
    .el-tabs__nav-next {
        line-height: 60px;
        font-size: 20px;
    }
     
}
</style>
<style scoped>
.box8_cent_right .el-select{
        width: 100%;
         
    }
.box8_cent_right{
    flex: 1;
}
.box1_heng{
    height: 25px;
    width: 1px;
    background-color: #aaa;
    position: absolute;
    right: 0;
}
.box1_cent:last-child .box1_heng{
    width: 0;
}
.box1_cent{
    width: 16.66%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    height: 100%;
    cursor: pointer;
    position: relative;
}
.box1_cent_sty{
    background-color: #0170c1;
    border-radius: 8px;
    color: #fff;
}
.box {
    /* background: url('../../assets/images/qie/11.jpg'); */
    background-size: 100% 100%;
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.box_top_img {
    width: 905px;
    /* height: 51px; */
    position: absolute;
    top: 12%;
    z-index: 2;
}

.box_bot {
    display: flex;
    align-items: center;
    position: absolute;
    justify-content: center;
    bottom: 11%;
    width: 70%;
    margin: 0 auto;
    min-width: 1200px;
}



.box_bot_cet {
    width: 100%;
    height: 50px;
    background-color: #ffffff;
    border-radius: 27px;
    min-width: 900px;
    padding: 7px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.box_bot_cet_left {
    flex: 1;
    font-size: 18px;
    padding: 0 20px;
}

.box_bot_cet_right {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 103px;
    height: 43px;
    background-color: #0170c1;
    border-radius: 21px;
    font-size: 18px;
    color: #ffffff;
    cursor: pointer;
}

.box9 {
    /* padding: 25px; */
    /* margin-top: 14px; */
}

.box1 {
    margin-top: 20px;
    border-radius: 10px;
    overflow: hidden;
    background-color: #fff;
}

.detaii {
    padding: 8px;
    color: #fff;
    background-color: #0170c1;
    border-radius: 10px;
    text-align: center;
    width: 80%;
    margin: 0 auto;
    cursor: pointer;
}

.pagecss {
    background-color: #f6f8f7;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 40px auto;
    margin-bottom: 0;
}

.box2 {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.box2_left {
    /* width: 70%; */
    /* width: 1064px; */
    width: 1144px;
    border-radius: 10px;
}

.box2_until_center {
    display: flex;
}

.box2_until_left {
    font-size: 14px;
    color: #959595;
    width: 65px;
    line-height: 28px;
}

.box2_until_right {
    height: 28px;
    font-size: 14px;
    line-height: 28px;
    padding: 0 8px;
    color: #4e4e4e;
    margin-left: 22px;
    margin-bottom: 10px;
}

.borbot {
    border-bottom: 1px solid #eee;
}

.box2_cent {
    display: flex;
    width: 93%;
    flex-wrap: wrap;
    min-height: 38px;
}

.box2_height1 {
    max-height: 380px;
    overflow: hidden;
}

.box5 {
    width: 100%;
    display: flex;
    min-height: 50px;
    border-bottom: 1px solid #f1f1f1;
}

.box5_text1 {
    width: 31%;
    display: flex;
    align-items: center;
    border-right: 1px solid #f1f1f1;
    border-left: 1px solid #f1f1f1;
    padding: 5px;
}

.box5_text2 {
    width: 14%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #f1f1f1;
    padding: 5px;
}

.box5_text3 {
    width: 13%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #f1f1f1;
    padding: 5px;
}

.sty {
    color: #ffffff;
    background: #0070c0;
}

.box2_cc {
    color: #ffffff;
    background-color: #0070c0;
}

.box2_nei {
    /* width: 95px; */
    height: 30px;
    padding: 0 15px;
    /* background-color: #ff6c00; */
    background-color: #0160a3;
    color: #ffffff;
    border-radius: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.box1_header_text {
    font-size: 20px;
    color: #191919;
    margin-left: 10px;
    font-weight: 600;
}

.box1_header_shu {
    width: 4px;
    height: 21px;
    background-color: #0070c0;
}

.box1_header {
    /* height: 77px; */
    display: flex;
    align-items: center;
}
.box8{
    display: flex;
    align-items: center;
    justify-content: space-between;
    
}
.box8_cent{
    display: flex;
    align-items: center;
    width:45%;
    justify-content: center;
}
.box8_cent_left{
    font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// enterprise.vue?0abcb9eb